<template>
  <div v-if="isValid">
    <v-main>
      <v-container>
        <v-form ref="form" lazy-validation>
          <v-flex xs12 text-xs-center>
            <v-img
              :src="require('../assets/hp-logo.gif')"
              class="my-3"
              contain
              height="100"
            ></v-img>
          </v-flex>

          <v-flex xs12 text-xs-center>
            <h1 class="display-2 font-weight-bold mb-3" align="center">
              {{ companyName }}
            </h1>
          </v-flex>
          <br />

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              1. How would you rate our support to launch and run your event?
            </h2>

            <v-radio-group
              v-model="answers.event"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              2. How would you rate our communication with you?
            </h2>

            <v-radio-group
              v-model="answers.communication"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              3. Has the event had a positive impact on your organisation?
            </h2>

            <v-radio-group
              v-model="answers.impact"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              4. Please rate our overall performance from the start to end of
              your event.
            </h2>

            <v-radio-group
              v-model="answers.performance"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              5. How would you rate value for money for the service?
            </h2>

            <v-radio-group
              v-model="answers.valueformoney"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              6. We love all feedback (good and bad) so please let us know any
              additional comments you may have.
            </h2>

            <v-textarea
              v-model="answers.feedback"
              name="input-7-1"
              filled
              label="Please type here..."
            ></v-textarea>
          </v-flex>

          <v-btn color="#b0cf3d" class="float-right mb-10" @click="save"
            >Submit</v-btn
          >
        </v-form>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import { getSurveyCompany2022 } from "../graphql/queries";
import { updateSurveyCompany2022 } from "../graphql/mutations";
export default {
  created() {
    API.graphql(
      graphqlOperation(getSurveyCompany2022, {
        id: this.$route.params.id,
      })
    )
      .then(result => {
        this.isValid = true;
        let answer = result.data.getSurveyCompany2022;
        this.companyName = answer.companyName + " " + new Date().getFullYear();
        this.answers = {};
        for (var property in answer) {
          if (answer.hasOwnProperty(property)) {
            if (answer[property]) {
              this.answers[property] = answer[property];
            }
          }
        }
      })
      .catch(() => {
        this.isValid = false;
      });
  },
  data: () => ({
    answers: [],
    isValid: true,
    companyName: "",
    rules: {
      required: v => !!v || "This field is required."
    }
  }),
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        const company = {
          id: this.answers.id,
          event: this.answers.event,
          communication: this.answers.communication,
          impact: this.answers.impact,
          performance: this.answers.performance,
          valueformoney: this.answers.valueformoney,
          feedback: this.answers.feedback
        };

        API.graphql(
          graphqlOperation(updateSurveyCompany2022, {
            input: company
          })
        )
          .then(() => {
            this.$router.push({ path: "/thankyou" });
          })
          .catch(error => (this.error = error.message));
      }
    }
  }
};
</script>
<style>
.v-radio {
  margin-right: 50px;
}
</style>
